export const primary = {
  50: '#f0fbff',
  100: '#e4f6ff',
  150: '#d7f2fe',
  200: '#cbedfd',
  250: '#bceafe',
  300: '#ade7ff',
  350: '#9de3ff',
  400: '#8ce0ff',
  450: '#5ac9ff',
  500: '#26aeff',
  550: '#008fff',
  600: '#146cfd',
  650: '#0c5ad4',
  700: '#0548ad',
  750: '#023688',
  800: '#002664',
  850: '#001a4d',
  900: '#001037',
  950: '#000622',
}
export const accent = {
  50: '#fff8f9',
  100: '#fff2f4',
  150: '#ffecef',
  200: '#ffe6ea',
  250: '#ffdbe0',
  300: '#ffcfd6',
  350: '#ffc4cc',
  400: '#ffb8c1',
  450: '#f897a2',
  500: '#ef7581',
  550: '#e44f5f',
  600: '#d7153a',
  650: '#b90e32',
  700: '#9b072a',
  750: '#7e0322',
  800: '#630019',
  850: '#4c0010',
  900: '#360008',
  950: '#210003',
}
export const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  150: '#f0f0f0',
  200: '#ebebeb',
  250: '#e3e5e6',
  300: '#dcdfe0',
  350: '#d4d9db',
  400: '#cdd3d6',
  450: '#aab0b4',
  500: '#888f92',
  550: '#686f72',
  600: '#495054',
  650: '#3f4549',
  700: '#353b3f',
  750: '#2b3135',
  800: '#22272b',
  850: '#181c1f',
  900: '#0e1113',
  950: '#050709',
}
